import React from 'react';
import { useTypedTranslation } from '@app/hooks';
import { PasslyTextField, PasslyCheckbox, PageLoader } from '@app/components';
import { IRequirementSwitch, RequirementTypes } from '@app/models';
import { InputNumber } from '@itglue/kaseya-ui';
import {PasslyTooltip} from '@app/componentsV2';

interface IProps {
    loadingData?: boolean;
    onChange: (e: any) => void;
    displayName: string;
    minimumLength: number;
    maximumLength: number;
    requirementsSwitchesData: IRequirementSwitch[];
    handleRequirementsChange: (name: RequirementTypes, value: boolean) => () => void;
}

const minLength: number = 1;
const maxLength: number = 255;

const PasswordServerPolicyDetails = ({ loadingData, onChange, displayName, minimumLength, maximumLength, requirementsSwitchesData, handleRequirementsChange }: IProps) => {
    const { translation } = useTypedTranslation();

    const handleMinMaxChange = (obj: { originalEvent: React.ChangeEvent; value: string | number; }) => {
        onChange(obj.originalEvent);
    };

    return loadingData ? (
        <span data-testid='page-loader'>
            <PageLoader isAbsolutePosition={true}/>
        </span>
    ) : (
        <>
            <div>
                <PasslyTextField
                    label={translation('POLICY_NAME')}
                    id='displayName-input'
                    name='displayName'
                    onChange={onChange}
                    type='text'
                    value={displayName}
                    inputProps={{ maxLength: 255 }}
                    required
                    autoFocus
                    fullWidth
                    data-testid='displayName-input'
                />
                <div className='right-panel__subtitle'>{translation('PASSWORD_REQUIREMENTS')}:</div>
                <div className='right-panel__row'>
                    <div className='right-panel__row-left-col'>
                        {translation('PASSWORD_MIN_LENGTH')}
                    </div>
                    <div className='right-panel__row-right-col'>
                        <InputNumber
                            label={''}
                            name='minimumLength'
                            value={minimumLength}
                            onValueChange={onChange}
                            onChange={handleMinMaxChange}
                            showButtons
                            min={minLength}
                            max={maximumLength}
                        />
                        <div className='right-panel__row-right-col-text'>{translation('CHARACTERS').toLowerCase()}</div>
                    </div>
                </div>
                <div className='right-panel__row'>
                    <div className='right-panel__row-left-col'>
                        {translation('PASSWORD_MAX_LENGTH')}
                    </div>
                    <div className='right-panel__row-right-col'>
                        <InputNumber
                            label={''}
                            name='maximumLength'
                            value={maximumLength}
                            onValueChange={onChange}
                            onChange={handleMinMaxChange}
                            showButtons
                            min={minLength}
                            max={maxLength}
                        />
                        <div className='right-panel__row-right-col-text'>{translation('CHARACTERS').toLowerCase()}</div>
                    </div>
                </div>
            </div>
            {requirementsSwitchesData.map((requirement: IRequirementSwitch, key: number) => (
                <div key={key} className='right-panel__row' data-testid={requirement.type}>
                    <PasslyCheckbox
                        name={''}
                        label={translation(requirement.label)}
                        checked={requirement.checked}
                        onChange={handleRequirementsChange(requirement.type, requirement.checked)}
                    />
                    {requirement.tooltip ? (<PasslyTooltip title={translation(requirement.tooltip)}>
                        <span className='right-panel__info-icon'><i className='far fa-info-circle' /></span>
                    </PasslyTooltip>) : null}
                </div>
            ))}
        </>
    );
};

export default PasswordServerPolicyDetails;
